(function () {
  'use strict';
  var STORAGE_KEY = 'smelu_popup_dismissed_at';
  var SESSION_KEY = 'smelu_popup_shown_session';

  function init(popup) {
    if (!popup) return;
    var cooldownDays = parseInt(popup.dataset.popupCooldownDays || '7', 10);
    var delayMs = parseInt(popup.dataset.popupDelayMs || '7000', 10);
    var scrollTrigger = 0.35; // 35% Scrolltiefe
    var opened = false, timer = null;

    // In dieser Sitzung schon gezeigt? -> nicht erneut
    try { if (sessionStorage.getItem(SESSION_KEY) === '1') return; } catch (e) {}

    // Cooldown (sitzungsuebergreifend) nach dem Schliessen
    if (cooldownDays > 0) {
      var lastDismissed = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
      if (lastDismissed && (Date.now() - lastDismissed) < cooldownMs) return;
    }

    var hasSuccess = popup.querySelector('[data-popup-success]');
    if (hasSuccess) { open(); return; }

    // Trigger: Zeit ODER Scroll ODER Exit-Intent -> was zuerst kommt
    timer = setTimeout(open, delayMs);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExit);

    function onScroll() {
      var d = document.documentElement, b = document.body;
      var st = window.pageYOffset || d.scrollTop || 0;
      var h = (d.scrollHeight || b.scrollHeight) - window.innerHeight;
      if (h > 0 && (st / h) >= scrollTrigger) open();
    }
    function onExit(e) {
      // Exit-Intent nur Desktop: Maus verlaesst das Fenster nach oben
      if ('ontouchstart' in window) return;
      if (!e.relatedTarget && (e.clientY == null || e.clientY <= 0)) open();
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.dataset.popupActive === 'true') close();
    });

    function cleanupTriggers() {
      if (timer) { clearTimeout(timer); timer = null; }
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
    }

    function open() {
      if (opened) return;
      opened = true;
      cleanupTriggers();
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      popup.dataset.popupActive = 'true';
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = popup.querySelector('input[type="email"]');
      if (input) { setTimeout(function () { input.focus(); }, 380); }
    }

    function close() {
      popup.dataset.popupActive = 'false';
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.smelu-popup').forEach(init);
    });
  } else {
    document.querySelectorAll('.smelu-popup').forEach(init);
  }
})();
